import { isVideoCallShortRoutePath } from "~/utils/videoCalls/invitation";

const VIDEO_CALL_ROUTE_PATTERN = /^\/video-call(?:\/|$)/;

export type VideoCallPrivacyWindow = {
  __teachplusVideoCallPrivacyActive?: boolean;
};

export const isVideoCallRoutePath = (path: string) => {
  const [pathname] = path.split(/[?#]/, 1);
  return (
    VIDEO_CALL_ROUTE_PATTERN.test(pathname) ||
    isVideoCallShortRoutePath(pathname)
  );
};

export const activateVideoCallPrivacy = (target: VideoCallPrivacyWindow) => {
  target.__teachplusVideoCallPrivacyActive = true;
};

export const deactivateVideoCallPrivacy = (target: VideoCallPrivacyWindow) => {
  delete target.__teachplusVideoCallPrivacyActive;
};
